import * as React from "react";
import { Utils } from "../../common/misc/Utils";
import { observer } from "mobx-react-lite";
import { TaskActivity } from "../types";
import { TaskViewVisualStore } from "../stores";
import { ActorBadge } from ".";

type Props = {
    activity: TaskActivity;
    userName: string;
    store: TaskViewVisualStore;
};

const TaskActivityEntry: React.FC<Props> = ({ activity, userName, store }) => {
    const displayName =
        activity.doneByActor?.type === "User" || !activity.doneByActor
            ? userName
            : activity.doneByActor.displayName || userName;

    return (
        <div className="task-activity-entry">
            <div className="activity-entry-content">
                <ActorBadge
                    store={store}
                    actor={activity.doneByActor}
                    legacyUserId={activity.doneBy}
                    legacyUserName={userName}
                    className="author-avatar"
                    size={24}
                    showName={false}
                />
                <div>
                    <span className="user-name">{displayName}</span>
                    <span className="activity-message">
                        {activity.activityType === "CommentUpdate" ||
                        activity.activityType === "CommentDelete" ||
                        activity.message.startsWith("updated Description") ? (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: activity.message,
                                }}
                            />
                        ) : (
                            activity.message
                        )}
                    </span>
                    <span className="activity-date">
                        {" "}
                        - {Utils.formatDateStringLong(activity.createdTime)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default observer(TaskActivityEntry);
